import React, { useState } from 'react';
import '../App.css';

const Projects = ({ onNavigate }) => {
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedProject, setSelectedProject] = useState(null);
    const [fadeOut, setFadeOut] = useState(false);
    const [rfadeOut, setRFadeOut] = useState(false);
    const [newSection, setNewSection] = useState(false);

    const projects = {
        apps: [
            { name: 'NotesGPT', info: 'Ask Questions From Your Notes Using AI', image: 'NotesGPTLogo.png', banner: 'NotesGPT.png', link: 'https://play.google.com/store/apps/details?id=com.byte9962.notesgpt', techstack: "MERN Stack", techDetails: "(MongoDB, ExpressJS, ReactJS, NodeJS)" },
            { name: 'SpacedR', info: 'Spaced Repetition App', image: 'SpacedRLogo.png', banner: 'SpacedR.png', link: 'https://play.google.com/store/apps/details?id=com.byte9962.spacedr', techstack: "MERN Stack", techDetails: "(MongoDB, ExpressJS, ReactJS, NodeJS)" },
            { name: 'Steganize', info: 'Hide Text in Image', image: 'SteganizeLogo.png', banner: 'Steganize.png', link: 'https://play.google.com/store/apps/details?id=com.byte9962.steganize', techstack: "MERN Stack", techDetails: "(MongoDB, ExpressJS, ReactJS, NodeJS)" },
            { name: 'CallStore', info: 'Automatic Call Recorder App', image: 'CallStoreLogo.png', banner: 'CallStore.png', link: 'https://play.google.com/store/apps/details?id=com.byte9962.callstore', techstack: "MERN Stack", techDetails: "(MongoDB, ExpressJS, ReactJS, NodeJS)" },
            { name: 'CustomURL', info: 'URL Bookmarking App', image: 'CustomURLLogo.png', banner: 'CustomURL.png', link: 'https://play.google.com/store/apps/details?id=com.byte9962.custom_url', techstack: "MERN Stack", techDetails: "(MongoDB, ExpressJS, ReactJS, NodeJS)" },
        ],
        websites: [
            { name: 'NotesGPT', info: 'Ask Questions From Your Notes Using AI', image: 'NotesGPTLogo.png', banner: 'NotesGPTWeb.png', link: 'https://notesgpt.app', techstack: "MERN Stack", techDetails: "(MongoDB, ExpressJS, ReactJS, NodeJS)" },
            { name: 'SpacedR', info: 'Spaced Repetition App', image: 'SpacedRLogo.png', banner: 'SpacedRWeb.png', link: 'https://spacedr2.netlify.app', techstack: "MERN Stack", techDetails: "(MongoDB, ExpressJS, ReactJS, NodeJS)" },
            { name: 'SantaCruz', info: 'A Basic SantaCruz Bike Concept Website', image: 'SantaCruzLogo.png', banner: 'SantaCruz.png', link: 'https://santacruz.netlify.app', techstack: "HTML, CSS, JavaScript" },
            { name: 'Old Portfolio', info: 'My Basic Old Portfolio', image: 'OldPortfolioLogo.png', banner: 'OldPortfolioWeb.png', link: 'https://hassaankh.netlify.app', techstack: "NodeJS, ExpressJS" },
        ],
        // games: [
        //     { name: 'Cubastic', info: 'Move forward avoiding the obstacles', image: 'cubastic.png', banner: 'CubasticGame.png', link: 'https://hassaankh.itch.io/cubastic', techstack: "Unity 3D" },
        //     { name: 'Cubigo', info: 'Move forward by jumping over the spikes', image: 'cubigo.png', banner: 'CubigoGame.png', link: 'https://hassaankh.itch.io/cubigo', techstack: "Unity 3D" },
        // ],
    };

    const handleCategoryChange = (category) => {
        setFadeOut(true);
        setTimeout(() => {
            setSelectedCategory(category);
            setSelectedProject(null); // Reset selected project
            setFadeOut(false);
        }, 200);
    };

    const handleProjectHover = (project) => {
        if (project) {
            setTimeout(() => {
                setRFadeOut(false); // Ensure fade-in
            }, 100)
            setSelectedProject(project);
        } else {
            setRFadeOut(true); // Start fade-out for the right section
            setSelectedProject(null); // Clear selected project after fade-out
        }
    };

    const handleBack = () => {
        setFadeOut(true);
        setTimeout(() => {
            setSelectedCategory(null);
            setSelectedProject(null); // Reset selected project
            setFadeOut(false);
        }, 300);
    };

    const handleBackProject = () => {
        setFadeOut(true);
        setTimeout(() => {
            setSelectedProject(null); // Reset selected project
            setNewSection(false)
            setFadeOut(false);
        }, 300);
    };

    const handleProjectClick = (project) => {
        setFadeOut(true)
        setSelectedProject(project);
        setTimeout(() => {
            setNewSection(true)
            setFadeOut(false)
        }, 200)
    }

    return (
        <div className='app'>
            <div className='container3'>
                <div className="links2">
                    <a
                        href="/"
                        className="link-projects"
                        onClick={(e) => {
                            e.preventDefault();
                            onNavigate('/');
                        }}
                    >
                        Home
                    </a>
                    <a
                        href="/projects"
                        className="link-projects"
                        onClick={(e) => {
                            e.preventDefault();
                            onNavigate('/about');
                        }}
                    >
                        About
                    </a>
                    <a
                        href="/contact"
                        className="link-projects"
                        onClick={(e) => {
                            e.preventDefault();
                            onNavigate('/contact');
                        }}
                    >
                        Contact
                    </a>
                </div>
                <div className='left-sectionpro'>

                    {newSection ? (
                        <>
                            <div>
                                {selectedProject && (
                                    <img src='arrow.png' className={`arrow ${fadeOut ? 'fade-out' : 'fade-in'}`} onClick={handleBackProject} alt="arrow"></img>
                                )}
                                <h1 className={`projects-heading ${fadeOut ? 'fade-out' : 'fade-in'}`} style={{ display: 'inline-block' }}>
                                    {selectedProject ? selectedProject.name : 'Projects'}
                                </h1>
                            </div>
                            <div>
                                {selectedProject && (
                                    <>
                                        <h1 className={` techeading ${fadeOut ? 'fade-out' : 'fade-in'}`}>Tech Stack:</h1>
                                        <p className={`tech-stack ${fadeOut ? 'fade-out' : 'fade-in'}`}>{selectedProject.techstack}</p>
                                        {selectedProject.techDetails && (
                                            <p className={`tech-stack ${fadeOut ? 'fade-out' : 'fade-in'}`}>{selectedProject.techDetails}</p>
                                        )}

                                        <p className={`clickheretovisit ${fadeOut ? 'fade-out' : 'fade-in'}`} onClick={() => { window.open(selectedProject.link, "_blank") }}>View</p>
                                    </>
                                )}
                            </div>
                        </>
                    ) : (
                        <>
                            <div>
                                {selectedCategory && (
                                    <img src='arrow.png' className={`arrow ${fadeOut ? 'fade-out' : 'fade-in'}`} onClick={handleBack} alt='arrow'></img>
                                )}
                                <h1 className={`projects-heading ${fadeOut ? 'fade-out' : 'fade-in'}`} style={{ display: 'inline-block' }}>
                                    {selectedCategory ? selectedCategory.charAt(0).toUpperCase() + selectedCategory.slice(1) : 'Projects'}
                                </h1>
                            </div>
                            {!selectedCategory && (
                                <div className={`button-container ${fadeOut ? 'fade-out' : 'fade-in'}`}>
                                    <button className="projbuttons" onClick={() => handleCategoryChange('apps')}>Apps</button>
                                    <button className="projbuttons" onClick={() => handleCategoryChange('websites')}>Websites</button>
                                    {/* <button className="projbuttons" onClick={() => handleCategoryChange('games')}>Games</button>
                                    <button className="projbuttons" onClick={() => handleCategoryChange('NFTs')}>NFTs</button> */}
                                </div>
                            )}

                            {selectedCategory && (
                                <div className={`projects-list ${fadeOut ? 'fade-out' : 'fade-in'}`}>
                                    {projects[selectedCategory]?.map((project, index) => (
                                        <div
                                            key={index}
                                        >
                                            <p className='projtitle' onMouseEnter={() => handleProjectHover(project)} onClick={() => { handleProjectClick(project) }}
                                                onMouseLeave={() => handleProjectHover(null)}>
                                                {project.name}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {selectedCategory === "NFTs" && (
                                <div className={`projects-list ${fadeOut ? 'fade-out' : 'fade-in'}`}>
                                    <div>
                                        <p className='projtitle' onMouseEnter={() => handleProjectHover({ name: "HappyCups" })} onClick={() => { window.open('https://opensea.io/collection/happy-cups', "_blank") }}
                                            onMouseLeave={() => handleProjectHover(null)}>
                                            HappyCups
                                        </p>
                                    </div>
                                </div>
                            )}
                            {selectedCategory === "apps" && (
                                <p className={`projtitle ${fadeOut ? 'fade-out' : 'fade-in'}`} onClick={() => { window.open("https://play.google.com/store/apps/dev?id=4656102232139250695", "_blank") }}>My Developer Console</p>
                            )}
                        </>
                    )}
                </div>

                <div className='right-sectionpro'>
                    {selectedProject?.name !== "HappyCups" && (
                        <div className={`${rfadeOut ? "fade-out-abrupt" : "fade-in"}`}>
                            <div className='project-data'>
                                {selectedProject?.image && (
                                    <img src={selectedProject?.image} alt={selectedProject?.name} className='project-image' />
                                )}
                                <div className='project-info'>
                                    <h1 className='projectname'>{selectedProject?.name}</h1>
                                    <p className='project-description'>{selectedProject?.info}</p>
                                </div>
                            </div>
                            {selectedProject?.banner && (
                                <img src={selectedProject?.banner} alt={selectedProject?.name} className='project-banner' />
                            )}
                        </div>
                    )}
                    {/* {selectedProject?.name === "HappyCups" && (
                        <div className={`${rfadeOut ? "fade-out-abrupt" : "fade-in"}`}>
                            <div>
                                <img src='NFT1.png' className='nftimg' alt='NFT'></img>
                                <img src='NFT2.png' className='nftimg' alt='NFT'></img>
                            </div>
                            <div>
                                <img src='NFT3.png' className='nftimg' alt='NFT'></img>
                                <img src='NFT4.png' className='nftimg' alt='NFT'></img>
                            </div>
                        </div>
                    )} */}
                </div>
            </div>
        </div>
    );
};

export default Projects;
